import React from "react";

import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { Popover } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";

import IconTextButton from "components/Button/IconTextButton";
import NestedCard from "components/Card/NestedCard";
import { Row } from "components/Layout";
import { Subtitle } from "components/Text";

import {
  selectNominationTotalsByGroupNameAndTermLookup,
  getTotalNominationQuantity,
} from "selectors";

export const NominationHdContainer = styled.div(
  ({ theme }) => `
  font-size: ${theme.fontSizes.charlie}px;
  font-weight: ${theme.fontWeights.bold};
`,
);

const Quantity = styled.span`
  font-size: 18px;
  margin-right: 10px;
  font-weight: bold;
`;

const DropDownRow = styled(Row)(
  ({ theme }) => `
display: flex;
flex-wrap: nowrap;
align-items: center;
margin: ${theme.space[2]}px;`,
);

const BreakLine = styled.hr`
  border: 1px solid ${({ theme }) => theme.colors.gray95};
  width: 100%;
  max-width: 800px;
`;

const totalSpeciesNominationAccessor = terms =>
  Object.values(terms).reduce((acc, quantity) => {
    return acc + quantity || 0;
  }, 0);

export const NominationOverview = () => {
  const totalNominationQuantity = useSelector(getTotalNominationQuantity);
  const nominationTotals = useSelector(
    selectNominationTotalsByGroupNameAndTermLookup,
  );

  const NominationTotals = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
      <>
        <DropDownRow>
          <NominationHdContainer>
            Total: {totalNominationQuantity}
          </NominationHdContainer>
          <IconTextButton icon={open ? faMinus : faPlus} onClick={handleClick}>
            {open ? `Hide details` : `Show details`}
          </IconTextButton>
        </DropDownRow>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          PaperProps={{
            style: { width: "100%", padding: "12px" },
          }}
        >
          {Object.entries(nominationTotals).map(
            ([groupName, terms], index, nominationTotals) => {
              return (
                <>
                  <NestedCard whiteBackground>
                    <Row>
                      <Grid
                        container
                        item
                        xs={5}
                        spacing={0}
                        justify="center"
                        direction="column"
                      >
                        <h3>
                          {groupName}
                          <Subtitle>
                            Total {totalSpeciesNominationAccessor(terms)}
                          </Subtitle>
                        </h3>
                      </Grid>
                      <Grid container item xs={7}>
                        {Object.entries(terms).map(([termName, quantity]) => {
                          return (
                            <Grid
                              key={termName}
                              item
                              xs={6}
                              style={{
                                marginBottom: "12px",
                                justifySelf: "center",
                              }}
                            >
                              <Subtitle>{termName}</Subtitle>
                              <Quantity>{quantity}</Quantity>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Row>
                  </NestedCard>
                  {index + 1 !== nominationTotals.length && <BreakLine />}
                </>
              );
            },
          )}
        </Popover>
      </>
    );
  };

  return (
    <Row>
      <Grid container>
        <Grid item xs={8} container spacing={0} alignItems="center">
          {totalNominationQuantity > 0 && <NominationTotals />}
        </Grid>
      </Grid>
    </Row>
  );
};
